import {Grid} from '@mui/material';
import Button from 'components/Button';
import {useFieldValue} from 'components/hook-form/useFieldValue';
import {CheckboxArrayProps} from 'components/inputs/FormikCheckboxArray';
import Panel from 'components/Panel';
import {findIndex} from 'lodash';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {IAdminRole} from 'types/diplomat/settings/adminroles/AdminRole';
import {IAdminRoles} from 'types/diplomat/settings/adminroles/AdminRoles';
import {RoleNames} from 'types/diplomat/settings/RoleNames';
import {useAdminRolesStyles} from './adminroles.styles';
import RolePrivileges from './RolePrivileges';
import RolesList, {RoleListProps} from './RolesList';

type Props = {
   refetch: RoleListProps['refetch'];
   onCreate: RoleListProps['onCreate'];
   onDelete: RoleListProps['onDelete'];
   selected: RoleListProps['selected'];
   select: RoleListProps['select'];
   hideItemsMenu?: RoleListProps['hideItemsMenu'];
   resourceTypes: CheckboxArrayProps['options'];
   labels: CheckboxArrayProps['labels'];
   vertical?: boolean;
};

const AdminRolesForm = ({
   refetch,
   onCreate,
   onDelete,
   hideItemsMenu,
   vertical,
   resourceTypes,
   labels,
   select,
   selected,
}: Props) => {
   const {t} = useTranslation();
   const classes = useAdminRolesStyles();
   const roles = useFieldValue<IAdminRoles>(RoleNames.roles) as IAdminRoles['roles'];

   const prefix = React.useMemo(() => {
      if (!selected) return '';
      // console.debug('selected', selected, roles, roles.indexOf(selected!));
      const index = findIndex(
         roles,
         (r) => r.id === selected.id && r.objectType === selected.objectType
      );
      return `roles[${index}].${RoleNames.resources}`;
   }, [roles, selected]);

   // const select = (role: IRole) => console.debug('Select role', role);

   return (
      <Grid container spacing={3}>
         <Grid item sm={vertical ? 12 : 6}>
            <Panel name={t('Roles')} className={classes.panel}>
               {roles.length ? (
                  <RolesList
                     selected={selected}
                     select={select}
                     refetch={refetch}
                     onCreate={onCreate}
                     onDelete={onDelete}
                     hideItemsMenu={hideItemsMenu}
                  />
               ) : (
                  <Button onClick={onCreate} size="large" sx={{margin: '0 auto', display: 'block'}}>
                     {t('Define Permissions')}
                  </Button>
               )}
            </Panel>
         </Grid>
         <Grid item sm={vertical ? 12 : 6}>
            <Panel name={t('Selected Role Privileges')} className={classes.panel}>
               <RolePrivileges
                  prefix={prefix}
                  resourceTypes={resourceTypes}
                  labels={labels}
                  disabled={Boolean((selected as IAdminRole)?.immutable)}
               />
            </Panel>
         </Grid>
      </Grid>
   );
};

export default AdminRolesForm;
